export const HOME = "/*";
export const MONDAY_DOT_COM = "/monday/*";
export const NOT_FOUND = "*";
